// extracted by mini-css-extract-plugin
export default {"heading":"CreatePhraseForm_heading__M8iiQ","formContainer":"CreatePhraseForm_formContainer__wtBK3","buttonContainer":"CreatePhraseForm_buttonContainer__z-tWR"};